export function formatDateTime(raw, includeSeconds = false) {
  if (raw == null || raw === "") return "—";
  const n = Number(raw);
  const d =
    Number.isFinite(n) && String(raw).length >= 12 ? new Date(n) : new Date(raw);
  if (Number.isNaN(d.getTime())) return String(raw);
  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: includeSeconds ? "2-digit" : undefined,
    hour12: true,
  });
}

export function formatDateShort(raw) {
  return formatDateTime(raw);
}

export function formatCallDuration(val) {
  if (val == null || val === "") return "—";
  const n = Number(val);
  if (!Number.isFinite(n)) return String(val);
  const totalSeconds = Math.round(n);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
}
